import '../scss/styles.scss';
import handleMenus from "./ScrollToSection"

export default function MobileMenu() {
    const handleCloseMenu = () => {
        let menu = document.querySelector( '.mobile-menu' );
		menu.classList.remove( 'active' );
    };

    return (
    <div className="mobile-menu">
        <div className="mobile-menu-wrapper">
            <button className="xmark" onClick={handleCloseMenu}></button>
            <ul>
                <li><a href="#home" onClick={handleMenus}>Home</a></li>
                <li><a href="#services" onClick={handleMenus}>Services</a></li>
                <li><a href="#inquire" onClick={handleMenus}>Equipment</a></li>
                <li><a href="#about" onClick={handleMenus}>About</a></li>
                <li><a href="#contact" onClick={handleMenus}>Contact</a></li>
                <li><a href="#book-now" onClick={handleMenus}>Get In Touch</a></li>
            </ul>
        </div>
    </div>
    )
}